import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterTotal from '@/components/Counter/SlotCounterTotal';
import dateUtils from '@/utils/dateUtil';
import SlotCounterStationSoldDistributionSheet from '@/components/Counter/SlotCounterStationSoldDistributionSheet';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'StationSale',
  components: {
    SlotCounterStationSoldDistributionSheet: SlotCounterStationSoldDistributionSheet,
    SlotCounterTotal: SlotCounterTotal
  },
  data: function data() {
    return {
      datePickerValue: (dateUtils.todayTimestamp() - 86400) * 1000,
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date();
        }
      }
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  methods: {
    monthStart: function monthStart(ts) {
      return moment(new Date(ts)).startOf('month').unix() * 1000;
    },
    monthEnd: function monthEnd(ts) {
      return moment(new Date(ts)).endOf('month').unix() * 1000;
    }
  }
};